export default "__VITE_ASSET__BGcKTrUf__"